// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"71812880","322":"71812880","628":"71812880"}[chunkId] + ".chunk.css";
};